import { all } from 'redux-saga/effects'

import watchUser from './userSaga'
import watchAudit from './auditSaga'

export default function* rootSaga() {
  yield all([
    watchUser(),
    watchAudit(),
  ])
}
